<template>
    <div>
        <ScrollList class="inspiration" :items="story.stories" :cols="4" @click="goToPage">
            <template v-slot:default="{card}">
                <b-card-text>
                    {{card.text}}
                </b-card-text>
            </template>
        </ScrollList>
        <ModuleTitle class="story-title" :caption="story.title" :text="story.subTitle" :module="story">
            <template v-slot:default="{module}">
                <div class="module-btn">
                    <b-button class="btn dark" @click="redirect(module.btn.to)">{{module.btn.text}}</b-button>
                </div>
            </template>
        </ModuleTitle>
    </div>
</template>

<script>
    import ModuleTitle from '../../common/ModuleTitle'
    import ScrollList from '../../common/ScrollList'

    export default {
        name: 'homepageStory',
        props :{
            story: Object
        },
        components: {
            ModuleTitle,
            ScrollList,
        },
        methods: {
            redirect(path){
                this.$router.push({
                    path
                })
                document.scrollingElement.scrollTop = 0
            },
            goToPage(slug){
                this.$router.push({
                    path: '/stories/' + slug
                })
                document.scrollingElement.scrollTop = 0
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "../../../assets/style/var";

    .en {
        .story-title {
            /deep/ .module-title {
                line-height: 30px;
            }
           /deep/ .module-sub-title {
                margin-top: 12px !important;
            }

            .btn-secondary {
                margin-top: 22px !important;
            }
        }
        .inspiration {
            .card-text {
                font-size: 20px!important;
                font-family: Montserrat-Medium, Helvetica, Arial, sans-serif !important;
            }
        }
    }

    .story-title {
        padding-top: 80px !important;
    }

    .inspiration {
        //display: inline-block;
        margin-top: 100px;
        margin-bottom: 0;

        &.list {
            //padding-bottom: 35% !important;
        }

        .card {
            max-width: 50rem !important;

            .card-text {
                max-width: 80%;
            }
        }

        .card-text {
            position: absolute;
            left: 50%;
            top: 76%;
            width: 100%;
            transform: translateX(-50%);
            text-align: center;
            font-size: 22px;
            line-height: 33px;
            color: @primary-light-color;
            font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
        }
    }
</style>
